import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleGrid"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/SimpleGrid/SimpleGrid.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/components/EarlyAccessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/HomeHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/MentorCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/components/ProcessSection.tsx");
